import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { FuelManagementWorkspaceComponent } from './fuel-management-workspace.component';

export const fuelManagementRoutes: Routes = [
  {
    path: 'fuel-management',
    canActivateChild: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: { enterpriseModules: ['FUEL_MANAGEMENT'], enterpriseFeatureLabel: 'Fuel Management' },
    children: [
      { path: '', component: FuelManagementWorkspaceComponent, data: { page: 'overview', permission: app_permissions.fuel_management.reports.view, scope: 'ANY' } },
      { path: 'marketplace', component: FuelManagementWorkspaceComponent, data: { page: 'marketplace', permission: app_permissions.fuel_management.marketplace.view } },
      { path: 'connections', component: FuelManagementWorkspaceComponent, data: { page: 'connections', permission: app_permissions.fuel_management.connections.manage } },
      { path: 'transactions', component: FuelManagementWorkspaceComponent, data: { page: 'transactions', permission: app_permissions.fuel_management.transactions.view } },
      { path: 'reports', component: FuelManagementWorkspaceComponent, data: { page: 'reports', permission: app_permissions.fuel_management.reports.view, scope: 'ANY' } }
    ]
  }
];
